import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { JobMatchAction } from 'src/app/core/models/jobMatchAction';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobService } from 'src/app/core/services/job.service';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { CompareAndUpdateCandidateDetailsModalComponent } from '../../compare-and-update-candidate-details/compare-and-update-candidate-details-modal/compare-and-update-candidate-details-modal.component';
import { UploadResumesActionsModalComponent } from '../upload-resumes-actions-modal/upload-resumes-actions-modal.component';
import { UploadResumesTransactionCandidatesModalComponent } from '../upload-resumes-transaction-candidates-modal/upload-resumes-transaction-candidates-modal.component';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';

declare var libphonenumber: any;
declare var bootbox: any;

@Component({
  selector: 'app-upload-resumes-processed-candidates',
  templateUrl: './upload-resumes-processed-candidates.component.html'
})
export class UploadResumesProcessedCandidatesComponent implements OnInit {

  @Input() candidatesCount: any;
  @Input() jobId: any;
  @Input() candidateId: any;
  @Input() notificationId: any;
  @Input() headingTitle: any;
  @Input() outreachSent = false;
  @Output() outreachSentCallback = new EventEmitter<void>();
  @Output() cancelCallback = new EventEmitter<void>();
  @Output() candidateProcessedCallback = new EventEmitter<void>();
  @Output() completeCallback = new EventEmitter<void>();

  userId: any;
  companyId: any;
  gettingCountsFlag = false;
  resumeList: any[] = [];
  uploadResumesResponse: any;
  totalUploads: any;
  candidatesList: any[] = [];
  candidatesToAssociateList: any[] = [];
  candidateCount: any;
  createJobMatchesObject: any;
  ResumeProcessedCandidatesList: any[] = [];

  showCandidateUpdateFailureMessage = false;
  isSingleCandidateUpload = false;
  fileExistsFlag = false;
  fileUploadInProgressFlag = false;
  mandatoryFieldsError = false;
  disableSourceTypesFlag = false;
  resumeScoringDoneFlag = false;
  scoringCandidatesFlag = false;
  jobContextExistsFlag = false;
  associatingCandidatesFlag = false;
  selectedAllCandidatesFlag = false;
  displaySelectDeselectButtonFlag = true;
  additionalMatchRuleVerifiedCopy = false;
  additionalMatchRuleVerificationPassedCopy = false;
  isDirectCandidateUpdate = true;
  sendOutreachEmailMultipleResume = false;
  sendOutreachEmailJobContext = false;
  sendOutreachEmailSingleResume = false;
  completeResumeSavingFlag = false;
  completeSendOutreachAssociatingCandidatesFlag = false;
  isOutreachEnabled = false;
  activityMap: any[] = [];
  candidateDetailsToUpdate: any;
  fetchOldCandidateDetails: any;

  constructor(
    private jobMatchActionsService: JobMatchActionsService,
    private bsModalService: BsModalService,
    private angularModalService: AngularModalService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService,
    private jobMatchService: JobMatchService,
    private candidateService: CandidateService,
    private jobService: JobService,
    private notificationsService: NotificationsService,
    private authService: AuthService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe
  ) { }

  ngOnInit() {
    this.userId = this.authService.getUserDetails().id;
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.gettingCountsFlag = false;
    if (!this.candidatesCount) {
      this.candidatesCount = {};
    } else {
      this._checkDuplicatesCandidatesExists();
    }

    this.initVariables();

    if (this.candidateId) {
      this.isSingleCandidateUpload = true;
    }
    if (this.jobId) {
      this.jobContextExistsFlag = true;
      this.createJobMatchesObject = {
        companyId: this.companyId,
        requisitionId: this.jobId,
        candidateIds: [],
        manuallyMatchedFromUI: true,
        transactionId: null,
        isAssociateCandidate: false,
        overrideNoteDetails: []
      };
    }
    this.resumeList = [];
    // A resume that was not processed comes back as an entry with no candidate id, so it has no row to show.
    this.candidatesList = (this.candidatesCount.candidates || []).filter(candidate => candidate.candidateId);
    this._setDetails();
    this._checkIfOutreachEnabled();
    this.candidatesCount.createdCount = this.candidatesCount.create ? this.candidatesCount.create.matchedCandidateCount + this.candidatesCount.create.unMatchedCandidateCount : 0;
    this.candidatesCount.updatedCount = this.candidatesCount.update ? this.candidatesCount.update.matchedCandidateCount + this.candidatesCount.update.unMatchedCandidateCount : 0;
  }

  initVariables() {
    this.resumeList = [];
    this.uploadResumesResponse = null;
    this.totalUploads = null;
    this.candidatesToAssociateList = [];
    this.candidateCount = null;
    this.createJobMatchesObject = null;
    this.ResumeProcessedCandidatesList = [];
    this.showCandidateUpdateFailureMessage = false;
    this.isSingleCandidateUpload = false;
    this.fileExistsFlag = false;
    this.fileUploadInProgressFlag = false;
    this.mandatoryFieldsError = false;
    this.disableSourceTypesFlag = false;
    this.resumeScoringDoneFlag = false;
    this.scoringCandidatesFlag = false;
    this.gettingCountsFlag = false;
    this.jobContextExistsFlag = false;
    this.associatingCandidatesFlag = false;
    this.selectedAllCandidatesFlag = false;
    this.displaySelectDeselectButtonFlag = true;
    this.additionalMatchRuleVerifiedCopy = false;
    this.additionalMatchRuleVerificationPassedCopy = false;
    this.isDirectCandidateUpdate = true;
    this.sendOutreachEmailMultipleResume = false;
    this.sendOutreachEmailJobContext = false;
    this.sendOutreachEmailSingleResume = false;
    this.completeResumeSavingFlag = false;
    this.completeSendOutreachAssociatingCandidatesFlag = false;
  }

  private _checkDuplicatesCandidatesExists() {
    if (this.candidatesCount.matchedCandidateIdAndNames) {
      this.candidatesCount.matchedCandidateIdAndNames = _.unique(this.candidatesCount.matchedCandidateIdAndNames, 'candidateId');
    }
    if (this.candidatesCount.unMatchedCandidateIdAndNames) {
      this.candidatesCount.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.unMatchedCandidateIdAndNames, 'candidateId');
    }
    if (this.candidatesCount.update) {
      if (this.candidatesCount.update.matchedCandidateIdAndNames) {
        this.candidatesCount.update.matchedCandidateIdAndNames = _.unique(this.candidatesCount.update.matchedCandidateIdAndNames, 'candidateId');
      }
      if (this.candidatesCount.update.unMatchedCandidateIdAndNames) {
        this.candidatesCount.update.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.update.unMatchedCandidateIdAndNames, 'candidateId');
      }
    }
    if (this.candidatesCount.create) {
      if (this.candidatesCount.create.matchedCandidateIdAndNames) {
        this.candidatesCount.create.matchedCandidateIdAndNames = _.unique(this.candidatesCount.create.matchedCandidateIdAndNames, 'candidateId');
      }
      if (this.candidatesCount.create.unMatchedCandidateIdAndNames) {
        this.candidatesCount.create.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.create.unMatchedCandidateIdAndNames, 'candidateId');
      }
    }
  }

  private _setDetails() {
    this._massageCandidateDetails();
    this._getCandidateCounts();
    this.getAllActivityTypes();

    this.candidatesList.forEach(candidate => {
      if (candidate.candidateId) {
        this.ResumeProcessedCandidatesList.push(candidate.candidateId);
      }
    });
  }

  private _massageCandidateDetails() {
    this.candidatesList.forEach(val => {
      if (val.firstName === null) {
        val.firstName = '-';
      }
      if (val.lastName === null) {
        val.lastName = '-';
      }
      if (val.email === null) {
        val.email = '-';
      }
      if (val.phone === null) {
        val.phone = '-';
      }
      val.name = val.firstName + ' ' + val.lastName;
      if (val.mobilePhoneCountryCodePresent) {
        const phoneNumberObject = libphonenumber.parse(val.phone.toString());
        if (phoneNumberObject.phone !== undefined) {
          val.phone = libphonenumber.format(
            phoneNumberObject.phone,
            phoneNumberObject.country,
            'International'
          );
        }
      }

      val.score = Math.floor(parseFloat(val.score));
      val.selectedFlag = false;
      if (val.score >= val.jobThresholdScore) {
        val.intelligenceScorePassFlag = true;
      }
      let candidateMatchedToJob = false;
      if (val.newCandidate && this.candidatesCount.create) {
        candidateMatchedToJob = !this.candidatesCount.create.unMatchedCandidateIdAndNames
          .map(can => can.candidateId)
          .includes(val.candidateId);
      }
      if (!val.newCandidate && this.candidatesCount.update) {
        candidateMatchedToJob = !this.candidatesCount.update.unMatchedCandidateIdAndNames
          .map(can => can.candidateId)
          .includes(val.candidateId);
      }
      val.candidateMatchedToJob = candidateMatchedToJob;
      if (val.candidateMatchedToJob) {
        val.allowManualMatch = false;
      }
    });
  }

  // The backend sends one generic "added" text (or none), so the message is built from what happened to the candidate.
  // Other backend statuses (suspension, override) are specific and kept as they are.
  getMatchStatus(candidate): string {
    const status = candidate.statusOfJobMatch;
    const genericAddedStatus = !status || /^Candidate added/i.test(status);
    const origin = candidate.newCandidate ? 'New candidate created' : 'Existing candidate updated';
    if (!this.jobContextExistsFlag) {
      return origin;
    }
    if (candidate.candidateMatchedToJob) {
      return genericAddedStatus ? origin + ' and added to the job' : status;
    }
    return genericAddedStatus ? origin + ', not matched to the job' : status;
  }

  private _checkIfOutreachEnabled() {
    this.isOutreachEnabled = true;
  }

  getAllActivityTypes() {
    this.activityMap = [];
    this.jobService.getActivityTypes((data) => {
      data.forEach(val => {
        this.activityMap[val.value] = val.name;
      });
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  runResumeScoringForAssociate(contactDetails?) {
    let isUpdate = false;
    if (contactDetails) {
      isUpdate = true;
      this.uploadResumesResponse.candidateContactDetail = contactDetails;
    }
    this.uploadResumesResponse.file = this.uploadResumesResponse.files[0];
    this.resumeService.runResumeScoringForAssociate(this.uploadResumesResponse, this.candidateId, this.jobId, isUpdate, (data) => {
      this.candidateDetailsToUpdate = data;
      if (!isUpdate) {
        this.additionalMatchRuleVerifiedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerified;
        this.additionalMatchRuleVerificationPassedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed;
      }
      const fetchNewCandidateDetails = {
        firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].newValue,
        lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].newValue,
        email: this.candidateDetailsToUpdate.candidateConflictDetails[2].newValue,
        phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].newValue
      };
      this.fetchOldCandidateDetails = {
        firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].oldValue,
        lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].oldValue,
        email: this.candidateDetailsToUpdate.candidateConflictDetails[2].oldValue,
        phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].oldValue
      };

      if (this.candidateDetailsToUpdate.candidateUpdated) {
        if (!isUpdate) {
          this.isDirectCandidateUpdate = true;
        }
        this.scoringCandidatesFlag = false;
        this.resumeScoringDoneFlag = true;
        this.candidatesList.push(fetchNewCandidateDetails);
      } else if (this.candidateDetailsToUpdate.candidateConflicts) {
        this.isDirectCandidateUpdate = false;
        this.showCandidateUpdateFailureMessage = true;
        this.scoringCandidatesFlag = false;
        this.resumeScoringDoneFlag = true;
        if (isUpdate) {
          this.candidateDetailsToUpdate.additionalMatchRuleVerified = this.additionalMatchRuleVerifiedCopy;
          this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed = this.additionalMatchRuleVerificationPassedCopy;
        }
      } else {
        this.isDirectCandidateUpdate = false;
        this._showConflictsModal(this.candidateDetailsToUpdate);
      }
      if (this.candidateProcessedCallback) {
        this.candidateProcessedCallback.emit();
      }
    }, () => {
    });
  }

  private _showConflictsModal(candidateConflictDetails) {
    this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      let bsModalRef: BsModalRef;
      const config = new ModalConfig();
      config.class = 'custom-modal-65';
      config.initialState = {
        resolve: {
          candidateConflictDetails
        },
        modalInstance: {
          close: (callbackObject) => {
            bsModalRef.hide();
            if (callbackObject.callbackType == 'save') {
              this.runResumeScoringForAssociate(callbackObject.entity);
            } else {
              this.scoringCandidatesFlag = false;
              this.resumeScoringDoneFlag = true;
              this.candidatesList = [];
              this.candidatesList.push(this.fetchOldCandidateDetails);
            }
          },
          dismiss: () => {
            bsModalRef.hide();
          }
        }
      };
      bsModalRef = this.bsModalService.show(CompareAndUpdateCandidateDetailsModalComponent, config);
    }, 300);
  }

  candidateToAssociateToggle(candidate) {
    if (candidate.selectedFlag) {
      this.candidatesToAssociateList.push(candidate);
    } else {
      _.remove(this.candidatesToAssociateList, {
        candidateId: candidate.candidateId
      });
      _.remove(this.createJobMatchesObject.overrideNoteDetails, {
        candidateId: candidate.candidateId
      });
    }
  }

  associateCandidates(successCallback?) {
    this.candidatesToAssociateList.forEach(val => {
      this.createJobMatchesObject.candidateIds.push(val.candidateId);
    });
    this.associatingCandidatesFlag = true;
    const associatingDialog = bootbox.dialog({
      message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
      closeButton: false
    });
    this.createJobMatchesObject.isAddCandidate = true;
    this.jobMatchService.createJobMatches(this.createJobMatchesObject, () => {
      this.associatingCandidatesFlag = false;
      associatingDialog.modal('hide');
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      this.candidatesToAssociateList.forEach(val => {
        const index = this.candidatesList.findIndex(c => c.candidateId === val.candidateId);
        this.candidatesList[index].candidateMatchedToJob = true;
        this.candidatesList[index].statusOfJobMatch = 'Candidate Added.';
        this.candidatesList[index].selectedFlag = false;
        this.candidatesList[index].jobMatchManuallyCreated = (this.candidatesList[index].score < this.candidatesList[index].jobThresholdScore);

        if (this.candidatesCount.update) {
          if (this.candidatesCount.update.unMatchedCandidateIdAndNames && this.candidatesCount.update.unMatchedCandidateIdAndNames.length > 0) {
            this.candidatesCount.update.unMatchedCandidateIdAndNames.forEach(candidate => {
              if (candidate.candidateId == val.candidateId) {
                this.candidatesCount.update.unMatchedCandidateCount--;
                this.candidatesCount.update.matchedCandidateCount++;
                this.candidatesCount.update.matchedCandidateIdAndNames.push(Object.assign({}, candidate, { jobMatchManuallyCreated: this.candidatesList[index].jobMatchManuallyCreated }));
                _.remove(this.candidatesCount.update.unMatchedCandidateIdAndNames, {
                  candidateId: val.candidateId
                });
              }
            });
          }
        }

        if (this.candidatesCount.create) {
          if (this.candidatesCount.create.unMatchedCandidateIdAndNames && this.candidatesCount.create.unMatchedCandidateIdAndNames.length > 0) {
            this.candidatesCount.create.unMatchedCandidateIdAndNames.forEach(candidate => {
              if (candidate.candidateId == val.candidateId) {
                this.candidatesCount.create.unMatchedCandidateCount--;
                this.candidatesCount.create.matchedCandidateCount++;
                this.candidatesCount.create.matchedCandidateIdAndNames.push(Object.assign({}, candidate, { jobMatchManuallyCreated: this.candidatesList[index].jobMatchManuallyCreated }));
                _.remove(this.candidatesCount.create.unMatchedCandidateIdAndNames, {
                  candidateId: val.candidateId
                });
              }
            });
          }
        }
      });
      this.candidatesCount.candidates = _.cloneDeep(this.candidatesList);

      this.candidatesToAssociateList = [];
      this._getCandidateCounts();

      // Runs after the outreach request so the sent flag reaches the open modal before it closes.
      const finishAssociating = () => {
        if (successCallback) {
          successCallback();
        } else {
          this.alertsAndNotificationsService.showBannerMessage('Candidates have be successfully added to the job', 'success');
          this.jobMatchService.requestJobWorkflowRefresh();
          if (this.notificationId) {
            this.notificationsService.saveCandidateResumeNotification(this.notificationId, this.candidatesCount, () => {
              if (this.completeCallback) {
                this.completeCallback.emit();
              }
            }, (error) => {
              this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
          } else {
            if (this.completeCallback) {
              this.completeCallback.emit();
            }
          }
        }
      };

      const matchedCandidateIds: any[] = this.candidatesList
        .filter(candidate => candidate.candidateMatchedToJob)
        .map(candidate => candidate.candidateId);

      if (this.sendOutreachEmailJobContext && this.isOutreachEnabled && !this.outreachSent && matchedCandidateIds.length > 0) {
        this._sendCandidateOutReachEmail(matchedCandidateIds, finishAssociating, this.notificationId);
      } else {
        finishAssociating();
      }
    }, (error) => {
      this.associatingCandidatesFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _getCandidateCounts() {
    this.displaySelectDeselectButtonFlag = (this.candidatesCount.create && this.candidatesCount.create.unMatchedCandidateCount !== 0) || (this.candidatesCount.update && this.candidatesCount.update.unMatchedCandidateCount !== 0);
  }

  showOverrideCandidateSuspensionModal(candidate) {
    const candidateId = candidate.candidateId;
    const candidateName = candidate.name;
    const suspendedMonths = candidate.overrideFor === 'RELEASE' ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
    const releaseDate = candidate.overrideFor === 'RELEASE' ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
    const allowOverride = candidate.allowOverride;
    const releasedJobDetails = candidate.overrideFor === 'RELEASE' ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
    const type = candidate.overrideFor === 'RELEASE' ? 'release' : 'jobLeft';

    if (allowOverride) {
      setTimeout(() => {
        let bsModalRef: BsModalRef;
        const config = new ModalConfig();
        config.class = 'custom-modal-65';
        config.initialState = {
          resolve: {
            candidateId,
            candidateName,
            suspendedMonths,
            releaseDate,
            allowOverride,
            releasedJobDetails,
            type
          },
          modalInstance: {
            close: (callbackObject) => {
              bsModalRef.hide();
              if (callbackObject.callbackType == 'save') {
                const index = this.candidatesList.findIndex(c => c.candidateId === candidate.candidateId);
                this.createJobMatchesObject.overrideNoteDetails.push(callbackObject.entity);
                this.candidatesList[index].allowManualMatch = true;
                this.candidatesList[index].showOverride = false;
                this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                this.candidatesList[index].selectedFlag = true;
                this.candidateToAssociateToggle(this.candidatesList[index]);
              }
            },
            dismiss: () => {
              bsModalRef.hide();
            }
          }
        };
        bsModalRef = this.bsModalService.show(UploadResumesActionsModalComponent, config);
      }, 300);
    } else {
      let displayHtmlText = '';
      if (type == 'release') {
        displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
        displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.fourDotFiveDateFormatPipe.transform(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
      } else {
        displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
        displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.fourDotFiveDateFormatPipe.transform(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
      }

      this.alertsAndNotificationsService.showAlertWithCallBack('Cannot add candidate', displayHtmlText, 'warning', () => {
        this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }
  }

  get hasSelectableCandidates(): boolean {
    return this.candidatesList.some(val => !val.candidateMatchedToJob && val.allowManualMatch);
  }

  toggleSelectAllCandidates() {
    if (this.selectedAllCandidatesFlag) {
      this.candidatesList.forEach(val => {
        if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
          val.selectedFlag = false;
          _.remove(this.candidatesToAssociateList, {
            candidateId: val.candidateId
          });
        }
      });
      this.selectedAllCandidatesFlag = false;
    } else {
      this.candidatesList.forEach(val => {
        if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
          val.selectedFlag = true;
          this.candidatesToAssociateList.push(val);
        }
      });
      this.selectedAllCandidatesFlag = true;
    }
  }

  jobCompare(candidate) {
    const actionObject = new JobMatchAction('Candidate Job Comparison', 'CANDIDATE_JOB_COMPARE', true, null);
    candidate.id = candidate.candidateId;
    candidate.jobMatchJobId = this.jobId;
    this.jobMatchActionsService.performAction('uploadResumes', actionObject, candidate, () => {
    }, () => {
    });
  }

  displayProcessedCandidates(activity) {
    this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      let bsModalRef: BsModalRef;
      const config = new ModalConfig();
      config.class = 'custom-modal-xl';
      config.initialState = {
        resolve: {
          resumeProcessedObject: this.candidatesCount,
          activity,
          modalType: 'resumeProcessed',
          activityMap: this.activityMap
        },
        modalInstance: {
          close: () => {
            bsModalRef.hide();
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          },
          dismiss: () => {
            bsModalRef.hide();
            this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          }
        }
      };
      bsModalRef = this.bsModalService.show(UploadResumesTransactionCandidatesModalComponent, config);
    }, 300);
  }

  // The notification id lets the backend flag the notification as outreach sent; a 200 response is reflected in the UI right away.
  private _sendCandidateOutReachEmail(candidateIds, successCallback, notificationId?) {
    const candidateIdsWithCandidateType: any[] = [];
    candidateIds.forEach(candidateId => {
      const candidate: any = { id: candidateId, candidateType: 'OWN_CANDIDATES' };
      if (this.jobId) {
        candidate.jobIds = [this.jobId];
      }
      candidateIdsWithCandidateType.push(candidate);
    });
    const outreachObject: any = {
      candidates: candidateIdsWithCandidateType,
      userId: this.userId,
      companyId: this.companyId,
      clientOrBuId: null
    };
    if (notificationId) {
      outreachObject.notificationId = notificationId;
    }
    this.candidateService.sendOutreachEmail(outreachObject, (data) => {
      this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
      if (notificationId) {
        this.outreachSent = true;
        this.outreachSentCallback.emit();
      }
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      if (successCallback) {
        successCallback();
      }
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  completeResumeProcessed(type) {
    this.completeResumeSavingFlag = true;
    const isSendOutreachEmailChecked = (type === 'multipleResume') ? this.sendOutreachEmailMultipleResume : this.sendOutreachEmailSingleResume;

    if (isSendOutreachEmailChecked && this.ResumeProcessedCandidatesList.length > 0 && this.isOutreachEnabled && !this.outreachSent) {
      this._sendCandidateOutReachEmail(this.ResumeProcessedCandidatesList, () => {
        this.completeResumeSavingFlag = false;
        if (this.completeCallback) {
          this.completeCallback.emit();
        }
      }, this.notificationId);
    } else {
      this.completeResumeSavingFlag = false;
      if (this.completeCallback) {
        this.completeCallback.emit();
      }
    }
  }

  sendOutreachToAssociatedCandidates() {
    this.completeSendOutreachAssociatingCandidatesFlag = true;
    const candidateIds: any[] = [];
    this.candidatesList.forEach(candidate => {
      if (candidate.candidateId) {
        candidateIds.push(candidate.candidateId);
      }
    });

    if (this.sendOutreachEmailJobContext && candidateIds.length > 0 && this.isOutreachEnabled && !this.outreachSent) {
      this._sendCandidateOutReachEmail(candidateIds, () => {
        this.completeSendOutreachAssociatingCandidatesFlag = false;
        if (this.completeCallback) {
          this.completeCallback.emit();
        }
      }, this.notificationId);
    } else {
      this.completeSendOutreachAssociatingCandidatesFlag = false;
      if (this.completeCallback) {
        this.completeCallback.emit();
      }
    }
  }
}
